'use strict';

var d3Format = require('d3-format');
var d3TimeFormat = require('d3-time-format');

var decimal = ",";
var thousands = ".";
var grouping = [
	3
];
var currency = [
	"",
	" €"
];
var deFormat = {
	decimal: decimal,
	thousands: thousands,
	grouping: grouping,
	currency: currency
};

var dateTime = "%A, der %e. %B %Y, %X";
var date = "%d.%m.%Y";
var time = "%H:%M:%S";
var periods = [
	"AM",
	"PM"
];
var days = [
	"Sonntag",
	"Montag",
	"Dienstag",
	"Mittwoch",
	"Donnerstag",
	"Freitag",
	"Samstag"
];
var shortDays = [
	"So",
	"Mo",
	"Di",
	"Mi",
	"Do",
	"Fr",
	"Sa"
];
var months = [
	"Januar",
	"Februar",
	"März",
	"April",
	"Mai",
	"Juni",
	"Juli",
	"August",
	"September",
	"Oktober",
	"November",
	"Dezember"
];
var shortMonths = [
	"Jan",
	"Feb",
	"Mrz",
	"Apr",
	"Mai",
	"Jun",
	"Jul",
	"Aug",
	"Sep",
	"Okt",
	"Nov",
	"Dez"
];
var deTimeFormat = {
	dateTime: dateTime,
	date: date,
	time: time,
	periods: periods,
	days: days,
	shortDays: shortDays,
	months: months,
	shortMonths: shortMonths
};

var decimal$1 = ".";
var thousands$1 = ",";
var grouping$1 = [
	3
];
var currency$1 = [
	"$",
	""
];
var enFormat = {
	decimal: decimal$1,
	thousands: thousands$1,
	grouping: grouping$1,
	currency: currency$1
};

var dateTime$1 = "%x, %X";
var date$1 = "%-m/%-d/%Y";
var time$1 = "%-I:%M:%S %p";
var periods$1 = [
	"AM",
	"PM"
];
var days$1 = [
	"Sunday",
	"Monday",
	"Tuesday",
	"Wednesday",
	"Thursday",
	"Friday",
	"Saturday"
];
var shortDays$1 = [
	"Sun",
	"Mon",
	"Tue",
	"Wed",
	"Thu",
	"Fri",
	"Sat"
];
var months$1 = [
	"January",
	"February",
	"March",
	"April",
	"May",
	"June",
	"July",
	"August",
	"September",
	"October",
	"November",
	"December"
];
var shortMonths$1 = [
	"Jan",
	"Feb",
	"Mar",
	"Apr",
	"May",
	"Jun",
	"Jul",
	"Aug",
	"Sep",
	"Oct",
	"Nov",
	"Dec"
];
var enTimeFormat = {
	dateTime: dateTime$1,
	date: date$1,
	time: time$1,
	periods: periods$1,
	days: days$1,
	shortDays: shortDays$1,
	months: months$1,
	shortMonths: shortMonths$1
};

var decimal$2 = ",";
var thousands$2 = ".";
var grouping$2 = [
	3
];
var currency$2 = [
	"",
	" €"
];
var esFormat = {
	decimal: decimal$2,
	thousands: thousands$2,
	grouping: grouping$2,
	currency: currency$2
};

var dateTime$2 = "%A, %e de %B de %Y, %X";
var date$2 = "%d/%m/%Y";
var time$2 = "%H:%M:%S";
var periods$2 = [
	"AM",
	"PM"
];
var days$2 = [
	"domingo",
	"lunes",
	"martes",
	"miércoles",
	"jueves",
	"viernes",
	"sábado"
];
var shortDays$2 = [
	"dom",
	"lun",
	"mar",
	"mié",
	"jue",
	"vie",
	"sáb"
];
var months$2 = [
	"enero",
	"febrero",
	"marzo",
	"abril",
	"mayo",
	"junio",
	"julio",
	"agosto",
	"septiembre",
	"octubre",
	"noviembre",
	"diciembre"
];
var shortMonths$2 = [
	"ene",
	"feb",
	"mar",
	"abr",
	"may",
	"jun",
	"jul",
	"ago",
	"sep",
	"oct",
	"nov",
	"dic"
];
var esTimeFormat = {
	dateTime: dateTime$2,
	date: date$2,
	time: time$2,
	periods: periods$2,
	days: days$2,
	shortDays: shortDays$2,
	months: months$2,
	shortMonths: shortMonths$2
};

var decimal$3 = ",";
var thousands$3 = " ";
var grouping$3 = [
	3
];
var currency$3 = [
	"",
	" €"
];
var percent = " %";
var frFormat = {
	decimal: decimal$3,
	thousands: thousands$3,
	grouping: grouping$3,
	currency: currency$3,
	percent: percent
};

var dateTime$3 = "%A %e %B %Y à %X";
var date$3 = "%d/%m/%Y";
var time$3 = "%H:%M:%S";
var periods$3 = [
	"AM",
	"PM"
];
var days$3 = [
	"dimanche",
	"lundi",
	"mardi",
	"mercredi",
	"jeudi",
	"vendredi",
	"samedi"
];
var shortDays$3 = [
	"dim.",
	"lun.",
	"mar.",
	"mer.",
	"jeu.",
	"ven.",
	"sam."
];
var months$3 = [
	"janvier",
	"février",
	"mars",
	"avril",
	"mai",
	"juin",
	"juillet",
	"août",
	"septembre",
	"octobre",
	"novembre",
	"décembre"
];
var shortMonths$3 = [
	"janv.",
	"févr.",
	"mars",
	"avr.",
	"mai",
	"juin",
	"juil.",
	"août",
	"sept.",
	"oct.",
	"nov.",
	"déc."
];
var frTimeFormat = {
	dateTime: dateTime$3,
	date: date$3,
	time: time$3,
	periods: periods$3,
	days: days$3,
	shortDays: shortDays$3,
	months: months$3,
	shortMonths: shortMonths$3
};

var decimal$4 = ",";
var thousands$4 = ".";
var grouping$4 = [
	3
];
var currency$4 = [
	"€",
	""
];
var itFormat = {
	decimal: decimal$4,
	thousands: thousands$4,
	grouping: grouping$4,
	currency: currency$4
};

var dateTime$4 = "%A %e %B %Y, %X";
var date$4 = "%d/%m/%Y";
var time$4 = "%H:%M:%S";
var periods$4 = [
	"AM",
	"PM"
];
var days$4 = [
	"Domenica",
	"Lunedì",
	"Martedì",
	"Mercoledì",
	"Giovedì",
	"Venerdì",
	"Sabato"
];
var shortDays$4 = [
	"Dom",
	"Lun",
	"Mar",
	"Mer",
	"Gio",
	"Ven",
	"Sab"
];
var months$4 = [
	"Gennaio",
	"Febbraio",
	"Marzo",
	"Aprile",
	"Maggio",
	"Giugno",
	"Luglio",
	"Agosto",
	"Settembre",
	"Ottobre",
	"Novembre",
	"Dicembre"
];
var shortMonths$4 = [
	"Gen",
	"Feb",
	"Mar",
	"Apr",
	"Mag",
	"Giu",
	"Lug",
	"Ago",
	"Set",
	"Ott",
	"Nov",
	"Dic"
];
var itTimeFormat = {
	dateTime: dateTime$4,
	date: date$4,
	time: time$4,
	periods: periods$4,
	days: days$4,
	shortDays: shortDays$4,
	months: months$4,
	shortMonths: shortMonths$4
};

var decimal$5 = ".";
var thousands$5 = ",";
var grouping$5 = [
	3
];
var currency$5 = [
	"",
	"円"
];
var jaFormat = {
	decimal: decimal$5,
	thousands: thousands$5,
	grouping: grouping$5,
	currency: currency$5
};

var dateTime$5 = "%x %a %X";
var date$5 = "%Y/%m/%d";
var time$5 = "%H:%M:%S";
var periods$5 = [
	"AM",
	"PM"
];
var days$5 = [
	"日曜日",
	"月曜日",
	"火曜日",
	"水曜日",
	"木曜日",
	"金曜日",
	"土曜日"
];
var shortDays$5 = [
	"日",
	"月",
	"火",
	"水",
	"木",
	"金",
	"土"
];
var months$5 = [
	"1月",
	"2月",
	"3月",
	"4月",
	"5月",
	"6月",
	"7月",
	"8月",
	"9月",
	"10月",
	"11月",
	"12月"
];
var shortMonths$5 = [
	"1月",
	"2月",
	"3月",
	"4月",
	"5月",
	"6月",
	"7月",
	"8月",
	"9月",
	"10月",
	"11月",
	"12月"
];
var jaTimeFormat = {
	dateTime: dateTime$5,
	date: date$5,
	time: time$5,
	periods: periods$5,
	days: days$5,
	shortDays: shortDays$5,
	months: months$5,
	shortMonths: shortMonths$5
};

const symbols = ['万', '億', '兆', '京', '垓', '𥝱', '穣', '溝', '澗', '正', '載', '極'];
const groupings = [1e4, 1e8, 1e12, 1e16, 1e20, 1e24, 1e28, 1e32, 1e36, 1e40, 1e44, 1e48];
symbols.reverse();
groupings.reverse();

var myriadFormatter = (localeInstance) => {
  const format = localeInstance.formatLocale.format;
  const { currency } = localeInstance.formatSpecifier;

  const formatMyriad = (parsedNumber, formatter, includesCurrency) => {
    const divisors = groupings.filter(d => d <= parsedNumber);
    let formattedNumber = '';
    let subtraction = 0;
    for (const i in divisors) {
      const divisor = divisors[i];
      const symbol = symbols.slice(-divisors.length)[i];
      const remainder = (parsedNumber - subtraction) / divisor;
      if (remainder === 0) break;
      const number = Math.floor(remainder);
      formattedNumber += `${number}${symbol}`;
      subtraction += number * divisor;
    }
    if (parsedNumber - subtraction > 0) formattedNumber += (parsedNumber - subtraction);
    return includesCurrency ? currency[0] + formattedNumber + currency[1] : formattedNumber;
  };

  return (formatSpecifier) => {
    if (!formatSpecifier.includes('s')) return format(formatSpecifier);
    const includesCurrency = formatSpecifier.includes('$');
    formatSpecifier = formatSpecifier.replace('~s', '').replace('s', '').replace('$', '');
    return (number) => {
      if (number < 1e4) return format(formatSpecifier)(number);
      // We format and parse to handle significant digits formatters, like .2
      const formattedNumber = format(formatSpecifier)(number);
      const parsedNumber = parseFloat(formattedNumber.replace(/,/g, ''));

      return formatMyriad(parsedNumber, format(formatSpecifier), includesCurrency);
    };
  };
};

var decimal$6 = ",";
var thousands$6 = ".";
var grouping$6 = [
	3
];
var currency$6 = [
	"R$",
	""
];
var ptFormat = {
	decimal: decimal$6,
	thousands: thousands$6,
	grouping: grouping$6,
	currency: currency$6
};

var dateTime$6 = "%A, %e de %B de %Y. %X";
var date$6 = "%d/%m/%Y";
var time$6 = "%H:%M:%S";
var periods$6 = [
	"AM",
	"PM"
];
var days$6 = [
	"Domingo",
	"Segunda",
	"Terça",
	"Quarta",
	"Quinta",
	"Sexta",
	"Sábado"
];
var shortDays$6 = [
	"Dom",
	"Seg",
	"Ter",
	"Qua",
	"Qui",
	"Sex",
	"Sáb"
];
var months$6 = [
	"Janeiro",
	"Fevereiro",
	"Março",
	"Abril",
	"Maio",
	"Junho",
	"Julho",
	"Agosto",
	"Setembro",
	"Outubro",
	"Novembro",
	"Dezembro"
];
var shortMonths$6 = [
	"Jan",
	"Fev",
	"Mar",
	"Abr",
	"Mai",
	"Jun",
	"Jul",
	"Ago",
	"Set",
	"Out",
	"Nov",
	"Dez"
];
var ptTimeFormat = {
	dateTime: dateTime$6,
	date: date$6,
	time: time$6,
	periods: periods$6,
	days: days$6,
	shortDays: shortDays$6,
	months: months$6,
	shortMonths: shortMonths$6
};

var decimal$7 = ".";
var thousands$7 = ",";
var grouping$7 = [
	3
];
var currency$7 = [
	"¥",
	""
];
var zhFormat = {
	decimal: decimal$7,
	thousands: thousands$7,
	grouping: grouping$7,
	currency: currency$7
};

var dateTime$7 = "%x %A %X";
var date$7 = "%Y年%-m月%-d日";
var time$7 = "%H:%M:%S";
var periods$7 = [
	"上午",
	"下午"
];
var days$7 = [
	"星期日",
	"星期一",
	"星期二",
	"星期三",
	"星期四",
	"星期五",
	"星期六"
];
var shortDays$7 = [
	"周日",
	"周一",
	"周二",
	"周三",
	"周四",
	"周五",
	"周六"
];
var months$7 = [
	"一月",
	"二月",
	"三月",
	"四月",
	"五月",
	"六月",
	"七月",
	"八月",
	"九月",
	"十月",
	"十一月",
	"十二月"
];
var shortMonths$7 = [
	"一月",
	"二月",
	"三月",
	"四月",
	"五月",
	"六月",
	"七月",
	"八月",
	"九月",
	"十月",
	"十一月",
	"十二月"
];
var zhTimeFormat = {
	dateTime: dateTime$7,
	date: date$7,
	time: time$7,
	periods: periods$7,
	days: days$7,
	shortDays: shortDays$7,
	months: months$7,
	shortMonths: shortMonths$7
};

class D3Locale {
  constructor(locale = 'en') {
    this._locale = locale;
    this._formatSpecifier = {};
    this._timeFormatSpecifier = {};
    this._apStyleDates = false;
  }

  get locale() {
    return this._locale;
  }

  set locale(locale) {
    this._locale = locale;
  }

  get formatSpecifier() {
    switch (this._locale) {
      case 'es':
        return { ...esFormat, ...this._formatSpecifier };
      case 'de':
        return { ...deFormat, ...this._formatSpecifier };
      case 'fr':
        return { ...frFormat, ...this._formatSpecifier };
      case 'it':
        return { ...itFormat, ...this._formatSpecifier };
      case 'ja':
        return { ...jaFormat, ...this._formatSpecifier };
      case 'pt':
        return { ...ptFormat, ...this._formatSpecifier };
      case 'zh':
        return { ...zhFormat, ...this._formatSpecifier };
      default:
        return { ...enFormat, ...this._formatSpecifier };
    }
  }

  set formatSpecifier(specifier) {
    this._formatSpecifier = specifier;
  }

  get formatLocale() {
    return d3Format.formatLocale(this.formatSpecifier);
  }

  get format() {
    // Special casing for Japanese/Chinese myriads
    if (
      this.locale === 'ja' ||
      this.locale === 'zh'
    ) return myriadFormatter(this);
    return this.formatLocale.format;
  }

  get timeFormatSpecifier() {
    switch (this._locale) {
      case 'es':
        return { ...esTimeFormat, ...this._timeFormatSpecifier };
      case 'de':
        return { ...deTimeFormat, ...this._timeFormatSpecifier };
      case 'fr':
        return { ...frTimeFormat, ...this._timeFormatSpecifier };
      case 'it':
        return { ...itTimeFormat, ...this._timeFormatSpecifier };
      case 'ja':
        return { ...jaTimeFormat, ...this._timeFormatSpecifier };
      case 'pt':
        return { ...ptTimeFormat, ...this._timeFormatSpecifier };
      case 'zh':
        return { ...zhTimeFormat, ...this._timeFormatSpecifier };
      default:
        return { ...enTimeFormat, ...this._timeFormatSpecifier };
    }
  }

  set timeFormatSpecifier(specifier) {
    this._timeFormatSpecifier = specifier;
  }

  get timeFormatLocale() {
    return d3TimeFormat.timeFormatLocale(this.timeFormatSpecifier);
  }

  get formatTime() {
    return this.timeFormatLocale.format;
  }

  apStyle() {
    if (this._locale !== 'en') return;
    this._timeFormatSpecifier = {
      ...this._timeFormatSpecifier,
      ...{
        shortMonths: ['Jan.', 'Feb.', 'March', 'April', 'May', 'June', 'July', 'Aug.', 'Sept.', 'Oct.', 'Nov.', 'Dec.'],
      },
    };
  }
}

module.exports = D3Locale;
